module.exports = __webpack_public_path__ + "img/MEDIA021.023902df.jpg";